import React from 'react';
import { Stack } from 'react-bootstrap';
import ClientDashboardProgressBar from './client-dashboard-progress-bar';
import ClientDashboardScatter from './client-dashboard-scatter';
import ClientDashboardAssessmentStatus from './client-dashboard-assessment-status';

const ClientDashboardCandidateCharts = ({ aggregations, assessmentsSummary, candidates }) => {
  return (
    <>
      {Object.keys(aggregations).length > 0 && (
        <>
          <Stack direction="horizontal" className="justify-content-evenly pb-3 d-none d-md-flex" gap={3}>
            <ClientDashboardProgressBar width={aggregations.highlyRecommend.percent} title="Recommend" />
            <ClientDashboardProgressBar width={aggregations.highPerform.percent} title="High Performance" />
            <ClientDashboardProgressBar width={aggregations.highLoyalty.percent} title="High Loyalty" />
          </Stack>
          <Stack direction="vertical" className="justify-content-evenly pb-3 d-md-none" gap={3}>
            <ClientDashboardProgressBar width={aggregations.highlyRecommend.percent} title="Recommend" />
            <ClientDashboardProgressBar width={aggregations.highPerform.percent} title="High Performance" />
            <ClientDashboardProgressBar width={aggregations.highLoyalty.percent} title="High Loyalty" />
          </Stack>
          <Stack direction="horizontal" className="pb-3 pb-3 d-none d-md-flex" gap={3}>
            <div className="chart-card flex-grow-1 w-100 h-100">
              <ClientDashboardScatter candidates={candidates} aggregations={aggregations} />
            </div>
            <div className="chart-card flex-grow-1 w-100 h-100">
              <ClientDashboardAssessmentStatus assessmentsSummary={assessmentsSummary} />
            </div>
          </Stack>
          <Stack direction="vertical" className="pb-3 pb-3 d-md-none" gap={3}>
            <div className="chart-card flex-grow-1 w-100 h-100">
              <ClientDashboardScatter candidates={candidates} aggregations={aggregations} />
            </div>
            <div className="chart-card flex-grow-1 w-100 h-100">
              <ClientDashboardAssessmentStatus assessmentsSummary={assessmentsSummary} />
            </div>
          </Stack>
        </>
      )}
    </>
  );
};

export default ClientDashboardCandidateCharts;
